import { SUPER_MINTER_ABI, SUPER_MINTER_ADDRESS } from '../../abi/super-minter.mjs';
import { mintTieredEditionArgs } from '../../helpers/mintTieredEditionArgs.mjs';

async function writeMintTieredEdition(client, args) {
  const { chain, gasLimit, value } = args;
  return client.writeContract({
    chain,
    abi: SUPER_MINTER_ABI,
    address: SUPER_MINTER_ADDRESS,
    functionName: "mintTo",
    args: mintTieredEditionArgs(args),
    account: client.account.address,
    gas: gasLimit,
    value
  });
}

export { writeMintTieredEdition };
